import React from 'react';
import { QrScanCollectorModal } from '@/common/QrScan';

const BulkSieveScanFilterModal = ({ visible, onCancel, onApply }) => (
  <QrScanCollectorModal
    visible={visible}
    onCancel={onCancel}
    onApply={onApply}
    title="Scan to Filter Sieve/Screen Items"
    description="Scan sieve/screen QR codes to build a filter. The table will show only the scanned items."
    noun={{ singular: 'item', plural: 'items' }}
    manualPlaceholder="Type sieve label (e.g. SV-123)"
    applyButtonText="Apply Filter"
  />
);

export default BulkSieveScanFilterModal;
